import styled from 'styled-components'

const StyledIcon = styled.a`
  cursor: pointer; 
`

StyledIcon.displayName = 'StyledIcon'

export default StyledIcon
